import _curry2 from "./internal/_curry2.js";
import _has from "./internal/_has.js";
var where = _curry2(function where(spec, testObj) {
    for (var prop in spec) {
        if (_has(prop, spec) && !spec[prop](testObj[prop])) {
            return false;
        }
    }
    return true;
});
export default where;
